import { useParams } from "react-router-dom";
import { MISSING_ID_IN_ROUTE, ROLE, STATUS } from "@/utils/constant";
import { FieldSelect } from "@/components/form/field-select";
import { useRFS } from "@/api/rfs";
import { useCurrentUser } from "@/features/auth/useCurrentUser";
import { hasCommonElement } from "@/utils/helper/hasCommonElement";

export function StatusFeeder() {
  const { id } = useParams();
  const { roles } = useCurrentUser();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { data: rfs } = useRFS({ id });
  const isViewOnly = hasCommonElement(roles, [ROLE.VENDOR_VIEW]);
  const isDisabled =
    rfs?.statusRfsSubmission === STATUS.RFS.REVISION_BY_LN ||
    rfs?.statusRfsSubmission === STATUS.RFS.GENERATING_HPDB ||
    isViewOnly;

  return (
    <>
      <FieldSelect
        label="Status Feeder"
        name="statusFeederAndOlt"
        hasRequiredAsterisk
        isDisabled={isDisabled}
        options={[
          {
            label: "OLT Done - Feeder Done",
            value: "OLT Done - Feeder Done",
          },
          {
            label: "OLT Done - Feeder NY",
            value: "OLT Done - Feeder NY",
          },
          {
            label: "OLS - Feeder Done",
            value: "OLS - Feeder Done",
          },
          {
            label: "OLS - Feeder NY",
            value: "OLS - Feeder NY",
          },
        ]}
      />
    </>
  );
}
